import {
  Dialog,
  IconButton,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "../../contactos/modalContacts.css";

import OportunidadesForm from "../OportunidadesForm";
import { ModalProgress } from "../../modals/ModalProgress";
import { ActivitiesSection } from "./ActivitiesSection";
import { CommercialActions } from './CommercialState';

export const DialogFormLeads = ({
  form,
  open,
  setOpen,
  funnels,
  tiposProspectos,
  listaClasificacionTask,
  listaOrigen,
  saveLead,
  updateForm,
  loading,
  onCommercialChange,
  commercialBusy,
}) => {
  const isMobile = useMediaQuery("(max-width:768px)");

  console.log({ form });

  return (
    <>
      {loading && <ModalProgress />}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullScreen={isMobile}
        PaperProps={{
          className: isMobile
            ? ""
            : form?.id
              ? "min-w-[90%]"
              : "min-w-[40%]"?.id
                ? "min-w-[90%]"
                : "min-w-[40%]",
        }}
      >
        <div
          className={`ContainerDialogs border-s-4 ${form?.estado === "archivado" ? "border-orange-500" : "border-green-500"}`}
        >
          <DialogTitle
            id="scroll-dialog-title"
            style={{ position: "absolute", right: "0px", top: "0px" }}
          >
            <IconButton
              aria-label="close"
              style={{ padding: "0", float: "right" }}
              onClick={() => setOpen(false)}
            >
              <CloseIcon style={{ color: "#78667E" }} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {form?.id && <CommercialActions lead={form} onChange={onCommercialChange} disabled={commercialBusy} />}
            {form?.id ? (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <OportunidadesForm
                    form={form}
                    funnels={funnels}
                    tiposProspectos={tiposProspectos}
                    listaOrigen={listaOrigen}
                    saveLead={saveLead}
                    updateForm={updateForm}
                  />
                </div>
                <div className="col-span-2 bg-[#f8f6f8]">
                  <ActivitiesSection
                    idOpor={form?.id || null}
                    infoOpor={form}
                    listaClasificacionTask={listaClasificacionTask}
                    listaOrigen={listaOrigen}
                  />
                </div>
              </div>
            ) : (
              <OportunidadesForm
                form={form}
                funnels={funnels}
                tiposProspectos={tiposProspectos}
                listaOrigen={listaOrigen}
                saveLead={saveLead}
                updateForm={updateForm}
              />
            )}
          </DialogContent>
        </div>
      </Dialog>
    </>
  );
};
